import config from '@/lib/config';
import TaggedActivity from '../templates/metrics/TaggedActivity';

const Energising = new TaggedActivity({
  name: 'Energising',
  tag: config.INSIGHTS.TAGS.ENERGISING,
});

export default Energising;
